<template>
  <div class="animated fadeIn">
    <b-card-text class="text-left">
      <p>
        Excellent!  ChatAcuity has started joining the selected channels. In order to access the Analytics Dashboard for your workspace, we will need a valid e-mail address to send your temporary password and login URL
      </p>

      <p>
        Click 'Next' to continue
      </p>

    </b-card-text>

    <b-button class="float-right" href="#" variant="primary" @click="nextButtonClick">Next</b-button>
  </div>
</template>


<script>
export default {
  name: 'Step2Part3',
  props: {

  },

  methods: {
    nextButtonClick() {
      this.$store.commit('installStep', 3)
      this.$router.push({ name: 'step3' })
    }
  },

  mounted() {
    this.$store.commit('installProgress', 65)
  }
}
</script>